import { EmailIcon, PhoneIcon } from 'components/icons';
import { Link, Spacer } from 'components';
import classes from 'classnames';
import styles from './BusinessInfo.module.scss';

export type BusinessInfoProps = {
  className?: string;
  businessHours: string;
  contactMail: string;
  contactPhone: string;
};

export default function BusinessInfo({
  className,
  businessHours,
  contactMail,
  contactPhone,
}: BusinessInfoProps) {
  return (
    <div
      className={classes(styles['business-info-container'], className)}
      data-test="businessInfoContainer"
    >
      <div className={styles['contact-info']} data-test="css-Email">
        <Link
          className={styles['active-link']}
          href={`mailto:${contactMail}`}
          leftIcon={<EmailIcon />}
        >
          <Spacer className={styles['contact-info-text']}>{contactMail}</Spacer>
        </Link>
      </div>

      <Spacer marginVertical={'3px'} />

      <div className={styles['contact-info']} data-test="css-Phone">
        <Link
          className={styles['active-link']}
          href={`tel:${contactPhone.replace(/\s/g, '')}`}
          leftIcon={<PhoneIcon />}
        >
          <Spacer className={styles['contact-info-text']}>
            {contactPhone}
          </Spacer>
        </Link>
      </div>

      <Spacer paddingTop="15px" data-test="css-Working-Hours">
        <div
          dangerouslySetInnerHTML={{
            __html: businessHours.replace(/,\s?/g, '<br />'),
          }}
          className={styles['business-hours']}
        />
      </Spacer>
    </div>
  );
}
